import { render, staticRenderFns } from "./IndicadoresHistoricoRentabilidadBruta.vue?vue&type=template&id=1538fd99&"
import script from "./IndicadoresHistoricoRentabilidadBruta.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoRentabilidadBruta.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoRentabilidadBruta.vue?vue&type=style&index=0&id=1538fd99&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports